import { Box, Divider, Typography, useTheme } from "@mui/material"
import { useTranslation } from "providers/i18n"
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIos"

export const StandardDirectionSummary = ({
  duration,
  distance,
  originName,
  destinationName,
}) => {
  const { t } = useTranslation()

  const theme = useTheme()

  const {
    directionSummaryContainer,
    durationText,
    distanceText,
    divider,
    locationSummaryContainer,
    locationContainer,
    locationText,
    directionSummaryArrowContainer,
  } = theme.components[`AppDirectionOverview`]?.styleOverrides || {}

  return (
    <Box sx={directionSummaryContainer}>
      <Typography sx={durationText}>
        {t("Travel Duration", { duration })}
      </Typography>
      <Typography sx={distanceText}>
        {t("Travel Distance", { distance })}
      </Typography>
      <Divider sx={divider} />
      <Box sx={locationSummaryContainer}>
        <Box sx={locationContainer}>
          <Typography sx={locationText}>{t(originName)}</Typography>
        </Box>
        <Box sx={directionSummaryArrowContainer}>
          <ArrowForwardIcon />
        </Box>
        <Box sx={locationContainer}>
          <Typography sx={locationText}>{t(destinationName)}</Typography>
        </Box>
      </Box>
    </Box>
  )
}
